import { NotificationManager } from "components/common/react-notifications";
import { toast } from "helpers/Utils";
import {
  AGENT_CASES_CONTRACT_MONTHLY_REPORT,
  AGENT_CASES_CONTRACT_MONTHLY_REPORT_FAILED,
  AGENT_CASES_CONTRACT_MONTHLY_REPORT_SUCCESS,
  AGENT_CASES_MONTHLY_REPORT,
  AGENT_CASES_MONTHLY_REPORT_FAILED,
  AGENT_CASES_MONTHLY_REPORT_SUCCESS,
  BOT_REPORT_DATA,
  BOT_REPORT_DATA_FAILED,
  BOT_REPORT_DATA_SUCCESS,
  COMPLAINT_MONTHLY_REPORT,
  COMPLAINT_MONTHLY_REPORT_FAILED,
  COMPLAINT_MONTHLY_REPORT_SUCCESS,
  COMPLAINT_REPORT_DATA,
  COMPLAINT_REPORT_DATA_FAILED,
  COMPLAINT_REPORT_DATA_SUCCESS,
  HCR_REPORT_DATA,
  HCR_REPORT_DATA_FAILED,
  HCR_REPORT_DATA_SUCCESS,
  HCR_REPORT_RESET,
  ENACH_REPORT_DATA,
  ENACH_REPORT_DATA_FAILED,
  ENACH_REPORT_DATA_SUCCESS,
  ENACH_REPORT_RESET,
  KYP_REPORT_DATA,
  KYP_REPORT_DATA_FAILED,
  KYP_REPORT_DATA_SUCCESS,
  KYP_REPORT_RESET,
  LEAD_REPORT_COUNT_DATA,
  LEAD_REPORT_COUNT_DATA_FAILED,
  LEAD_REPORT_COUNT_DATA_SUCCESS,
  LEAD_REPORT_DATA,
  LEAD_REPORT_DATA_FAILED,
  LEAD_REPORT_DATA_SUCCESS,
  LEAD_STATUS_REPORT,
  LEAD_STATUS_REPORT_FAILED,
  LEAD_STATUS_REPORT_SUCCESS,
  MONTHLY_REPORT_DATA,
  MONTHLY_REPORT_DATA_FAILED,
  MONTHLY_REPORT_DATA_SUCCESS,
  MONTHLY_RESOLVED_B2C,
  MONTHLY_RESOLVED_B2C_FAILED,
  MONTHLY_RESOLVED_B2C_SUCCESS,
  OMBUDSMAN_EXECUTIVE_REPORT,
  OMBUDSMAN_EXECUTIVE_REPORT_FAILED,
  OMBUDSMAN_EXECUTIVE_REPORT_SUCCESS,
  OMB_REJECT_CASES,
  OMB_REJECT_CASES_FAILED,
  OMB_REJECT_CASES_SUCCESS,
  PAYMENT_REPORT_DATA,
  PAYMENT_REPORT_DATA_FAILED,
  PAYMENT_REPORT_DATA_SUCCESS,
  PAYMENT_REPORT_STATUS_DATA,
  PAYMENT_REPORT_STATUS_DATA_FAILED,
  PAYMENT_REPORT_STATUS_DATA_SUCCESS,
  REGISTERED_LEAD_REPORT,
  REGISTERED_LEAD_REPORT_FAILED,
  REGISTERED_LEAD_REPORT_SUCCESS,
  REPORT_CASE_REPORT_AGENT_DATA,
  REPORT_CASE_REPORT_AGENT_DATA_FAILED,
  REPORT_CASE_REPORT_AGENT_DATA_SUCCESS,
  REPORT_CASE_REPORT_COUNT_DATA,
  REPORT_CASE_REPORT_COUNT_DATA_FAILED,
  REPORT_CASE_REPORT_COUNT_DATA_SUCCESS,
  REPORT_CASE_REPORT_DATA,
  REPORT_CASE_REPORT_DATA_FAILED,
  REPORT_CASE_REPORT_DATA_SUCCESS,
  REPORT_CASE_REPORT_STATUS_DATA,
  REPORT_CASE_REPORT_STATUS_DATA_FAILED,
  REPORT_CASE_REPORT_STATUS_DATA_SUCCESS,
  REPORT_DOWNLOAD_TAX_INVOICE,
  REPORT_DOWNLOAD_TAX_INVOICE_FAILED,
  REPORT_DOWNLOAD_TAX_INVOICE_SUCCESS,
  REPORT_GET_ACTIVE_STATUS,
  REPORT_GET_ACTIVE_STATUS_FAILED,
  REPORT_GET_ACTIVE_STATUS_SUCCESS,
  REPORT_GET_ALL_USER_LIST,
  REPORT_GET_ALL_USER_LIST_FAILED,
  REPORT_GET_ALL_USER_LIST_SUCCESS,
  REPORT_GET_COMPLAINT_TYPE,
  REPORT_GET_COMPLAINT_TYPE_FAILED,
  REPORT_GET_COMPLAINT_TYPE_SUCCESS,
  REPORT_GET_INSURANCE_COMPANIES,
  REPORT_GET_INSURANCE_COMPANIES_FAILED,
  REPORT_GET_INSURANCE_COMPANIES_SUCCESS,
  REPORT_GET_INSURANCE_TYPE,
  REPORT_GET_INSURANCE_TYPE_FAILED,
  REPORT_GET_INSURANCE_TYPE_SUCCESS,
  REPORT_GET_USER_AGENT_DATA,
  REPORT_GET_USER_AGENT_DATA_FAILED,
  REPORT_GET_USER_AGENT_DATA_SUCCESS,
  REPORT_RESOLVED_CASES,
  REPORT_RESOLVED_CASES_FAILED,
  REPORT_RESOLVED_CASES_SUCCESS,
  REPORT_RESOLVED_PAYMENT_CASES,
  REPORT_RESOLVED_PAYMENT_CASES_FAILED,
  REPORT_RESOLVED_PAYMENT_CASES_SUCCESS,
  REPORT_UPLOAD_DOC,
  REPORT_UPLOAD_DOC_FAILED,
  REPORT_UPLOAD_DOC_SUCCESS,
  REPORT_UPLOAD_TO_SERVER,
  REPORT_UPLOAD_TO_SERVER_FAILED,
  REPORT_UPLOAD_TO_SERVER_SUCCESS,
  REPORT_USER_REPORT_DATA,
  REPORT_USER_REPORT_DATA_FAILED,
  REPORT_USER_REPORT_DATA_SUCCESS,
  TAT_REPORT_DATA,
  TAT_REPORT_DATA_FAILED,
  TAT_REPORT_DATA_SUCCESS,
  TODAY_LEAD_COUNT_DATA,
  TODAY_LEAD_COUNT_DATA_FAILED,
  TODAY_LEAD_COUNT_DATA_SUCCESS
} from "./Action";

const initValue = {
  status: [],
  userAgent: [],
  allUsers: [],
  policyTypes: [],
  insuranceCom: [],
  comTypes: [],
  caseRep: [],
  caseRepCount: "",
  leadRepCount: "",
  todayLeadCount: {},
  leadRepData: [],
  payRepData: [],
  monthlyRepData: [],
  comMontlyRep: [],
  agentCases: [],
  agentCasesCon: [],
  compData: [],
  ombData: [],
  relPaymentData: [],
  regLead: [],
  monthlyB2C: [],
  ombRejectCases: [],
  tatData: [],
  botData: [],
  message: "",
  monthlyRepDataDownload: false,
  loading: false,
  assignUsers: [],
  invoiceData: [],
  invoiceReportCalled: false,
  leasReportDwnCalled: false,
  leadStatusData: [],
  uploadedReportData: false,
  loadingReport: false,
  kypData: [],
};

export default (state = initValue, action) => {
  let temp = [];
  let temp1 = [];
  switch (action.type) {
    case REPORT_GET_ACTIVE_STATUS:
      return { ...state };

    case REPORT_GET_ACTIVE_STATUS_SUCCESS:
      return { ...state, status: action.data };

    case REPORT_GET_ACTIVE_STATUS_FAILED:
      return { ...state, message: action.message };

    case REPORT_GET_USER_AGENT_DATA:
      return { ...state };

    case REPORT_GET_USER_AGENT_DATA_SUCCESS:
      return { ...state, userAgent: action.data };

    case REPORT_GET_USER_AGENT_DATA_FAILED:
      return { ...state, message: action.message };

    case REPORT_GET_ALL_USER_LIST:
      return { ...state };

    case REPORT_GET_ALL_USER_LIST_SUCCESS:
      return { ...state, allUsers: action.data };

    case REPORT_GET_ALL_USER_LIST_FAILED:
      return { ...state, message: action.message };

    case REPORT_GET_INSURANCE_TYPE:
      return { ...state };

    case REPORT_GET_INSURANCE_TYPE_SUCCESS:
      return { ...state, policyTypes: action.data };

    case REPORT_GET_INSURANCE_TYPE_FAILED:
      return { ...state, message: action.message };

    case REPORT_GET_INSURANCE_COMPANIES:
      return { ...state };

    case REPORT_GET_INSURANCE_COMPANIES_SUCCESS:
      return { ...state, insuranceCom: action.data };

    case REPORT_GET_INSURANCE_COMPANIES_FAILED:
      return { ...state, message: action.message };

    case REPORT_GET_COMPLAINT_TYPE:
      return { ...state };

    case REPORT_GET_COMPLAINT_TYPE_SUCCESS:
      return { ...state, comTypes: action.data };

    case REPORT_GET_COMPLAINT_TYPE_FAILED:
      return { ...state, message: action.message };

    case REPORT_UPLOAD_DOC:
      return { ...state, loadingReport: true };

    case REPORT_UPLOAD_DOC_SUCCESS:
      return { ...state, uploadedReportData: action?.data?.success, message: action.message, loadingReport: false };

    case REPORT_UPLOAD_DOC_FAILED:
      return { ...state, message: action.message, loadingReport: false };

    case REPORT_UPLOAD_TO_SERVER:
      return { ...state, loadingReport: true };

    case REPORT_UPLOAD_TO_SERVER_SUCCESS:
      if (action.message?.includes("Please check") || action.message?.includes("Not Uploaded")) {
        toast("", action.message, "error");
      } else {
        toast("", action.message, "success");
      }
      return { ...state, message: action.message, loadingReport: false };

    case REPORT_UPLOAD_TO_SERVER_FAILED:
      return { ...state, message: action.message, loadingReport: false };

    case REPORT_RESOLVED_CASES:
      return { ...state };

    case REPORT_RESOLVED_CASES_SUCCESS:
      return { ...state, resolveData: action.data };

    case REPORT_RESOLVED_CASES_FAILED:
      return { ...state, message: action.message };

    case REPORT_RESOLVED_PAYMENT_CASES:
      return { ...state };

    case REPORT_RESOLVED_PAYMENT_CASES_SUCCESS:
      return { ...state, relPaymentData: action.data };

    case REPORT_RESOLVED_PAYMENT_CASES_FAILED:
      return { ...state, message: action.message };

    case REPORT_CASE_REPORT_DATA:
      return { ...state, loading: true };

    case REPORT_CASE_REPORT_DATA_SUCCESS:
      return { ...state, caseRep: action.data, loading: false };

    case REPORT_CASE_REPORT_DATA_FAILED:
      return { ...state, message: action.message };

    case REPORT_CASE_REPORT_STATUS_DATA:
      return { ...state, loading: true };

    case REPORT_CASE_REPORT_STATUS_DATA_SUCCESS:
      return { ...state, caseRep: action.data, loading: false };

    case REPORT_CASE_REPORT_STATUS_DATA_FAILED:
      return { ...state, message: action.message };

    case REPORT_CASE_REPORT_AGENT_DATA:
      return { ...state, loading: true };

    case REPORT_CASE_REPORT_AGENT_DATA_SUCCESS:
      return { ...state, caseRep: action.data, loading: false };

    case REPORT_CASE_REPORT_AGENT_DATA_FAILED:
      return { ...state, message: action.message };

    case REPORT_CASE_REPORT_COUNT_DATA:
      return { ...state };

    case REPORT_CASE_REPORT_COUNT_DATA_SUCCESS:
      return { ...state, caseRepCount: action.data };

    case REPORT_CASE_REPORT_COUNT_DATA_FAILED:
      return { ...state, message: action.message };

    case LEAD_REPORT_COUNT_DATA:
      return { ...state };

    case LEAD_REPORT_COUNT_DATA_SUCCESS:
      NotificationManager.success("Total Lead Count !", "", 3000, null, null, "filled");
      return { ...state, leadRepCount: action.data };

    case LEAD_REPORT_COUNT_DATA_FAILED:
      return { ...state, message: action.message };

    case TODAY_LEAD_COUNT_DATA:
      return { ...state };

    case TODAY_LEAD_COUNT_DATA_SUCCESS:
      return { ...state, todayLeadCount: action.data };

    case TODAY_LEAD_COUNT_DATA_FAILED:
      return { ...state, message: action.message };

    case LEAD_REPORT_DATA:
      return { ...state };

    case LEAD_REPORT_DATA_SUCCESS:
      if (action.data?.data?.length) {
        toast("Success !", "Lead Count Successfully !", "success");
      } else {
        toast("", "No Record Found !", "error");
      }
      if (action.data.data?.length) {
        temp = action.data.data?.map((res) => {
          return { ...res, Communications: res.Communications?.replace(/"/g, '""'), "Problem Statement": res["Problem Statement"]?.replace(/"/g, '""') };
        });
      }
      return { ...state, leadRepData: temp };

    case LEAD_REPORT_DATA_FAILED:
      toast(`Something wrong !`, "Data is more than expeted, Failed to lead data !", "error");
      return { ...state, message: action.message, leadRepData: [] };

    case PAYMENT_REPORT_DATA:
      return { ...state };

    case PAYMENT_REPORT_DATA_SUCCESS:
      return { ...state, payRepData: action.data };

    case PAYMENT_REPORT_DATA_FAILED:
      return { ...state, message: action.message };

    case PAYMENT_REPORT_STATUS_DATA:
      return { ...state };

    case PAYMENT_REPORT_STATUS_DATA_SUCCESS:
      return { ...state, payRepData: action.data };

    case PAYMENT_REPORT_STATUS_DATA_FAILED:
      return { ...state, message: action.message };

    case MONTHLY_REPORT_DATA:
      return { ...state };

    case MONTHLY_REPORT_DATA_SUCCESS:
      return {
        ...state,
        monthlyRepData: action.data,
        monthlyRepDataDownload: true
      };

    case MONTHLY_REPORT_DATA_FAILED:
      return { ...state, message: action.message };

    case COMPLAINT_MONTHLY_REPORT:
      return { ...state };

    case COMPLAINT_MONTHLY_REPORT_SUCCESS:
      return { ...state, comMontlyRep: action.data };

    case COMPLAINT_MONTHLY_REPORT_FAILED:
      return { ...state, message: action.message };

    case AGENT_CASES_MONTHLY_REPORT:
      return { ...state };

    case AGENT_CASES_MONTHLY_REPORT_SUCCESS:
      return { ...state, agentCases: action.data };

    case AGENT_CASES_MONTHLY_REPORT_FAILED:
      return { ...state, message: action.message };

    case AGENT_CASES_CONTRACT_MONTHLY_REPORT:
      return { ...state };

    case AGENT_CASES_CONTRACT_MONTHLY_REPORT_SUCCESS:
      return { ...state, agentCasesCon: action.data };

    case AGENT_CASES_CONTRACT_MONTHLY_REPORT_FAILED:
      return { ...state, message: action.message };

    case COMPLAINT_REPORT_DATA:
      return { ...state };

    case COMPLAINT_REPORT_DATA_SUCCESS:
      return { ...state, compData: action.data };

    case COMPLAINT_REPORT_DATA_FAILED:
      return { ...state, message: action.message };

    case OMBUDSMAN_EXECUTIVE_REPORT:
      return { ...state };

    case OMBUDSMAN_EXECUTIVE_REPORT_SUCCESS:
      return { ...state, ombData: action.data };

    case OMBUDSMAN_EXECUTIVE_REPORT_FAILED:
      return { ...state, message: action.message };

    case REGISTERED_LEAD_REPORT:
      return { ...state };

    case REGISTERED_LEAD_REPORT_SUCCESS:
      return { ...state, regLead: action.data };

    case REGISTERED_LEAD_REPORT_FAILED:
      return { ...state, message: action.message };

    case MONTHLY_RESOLVED_B2C:
      return { ...state };

    case MONTHLY_RESOLVED_B2C_SUCCESS:
      return { ...state, monthlyB2C: action.data };

    case MONTHLY_RESOLVED_B2C_FAILED:
      return { ...state, message: action.message };

    case OMB_REJECT_CASES:
      return { ...state };

    case OMB_REJECT_CASES_SUCCESS:
      return { ...state, ombRejectCases: action.data };

    case OMB_REJECT_CASES_FAILED:
      return { ...state, message: action.message };

    case TAT_REPORT_DATA:
      return { ...state };

    case TAT_REPORT_DATA_SUCCESS:
      return { ...state, tatData: action.data };

    case TAT_REPORT_DATA_FAILED:
      return { ...state, message: action.message };

    case BOT_REPORT_DATA:
      return { ...state };

    case BOT_REPORT_DATA_SUCCESS:
      return { ...state, botData: action.data };

    case BOT_REPORT_DATA_FAILED:
      return { ...state, message: action.message };

    case REPORT_USER_REPORT_DATA:
      return { ...state };

    case REPORT_USER_REPORT_DATA_SUCCESS:
      return { ...state, assignUsers: action.data };

    case REPORT_USER_REPORT_DATA_FAILED:
      return { ...state };

    case REPORT_DOWNLOAD_TAX_INVOICE:
      return { ...state, invoiceReportCalled: false, loading: true };

    case REPORT_DOWNLOAD_TAX_INVOICE_SUCCESS:
      return { ...state, invoiceData: action.data || [], invoiceReportCalled: true, loading: false };

    case REPORT_DOWNLOAD_TAX_INVOICE_FAILED:
      return { ...state, loading: false };

    case LEAD_STATUS_REPORT:
      return { ...state, leasReportDwnCalled: true, loading: true };

    case LEAD_STATUS_REPORT_SUCCESS:
      if (action.data?.length) {
        temp1 = action.data?.map((res) => {
          return { ...res, "Problem Statement": res["Problem Statement"]?.replace(/"/g, '""') };
        });
      }
      return { ...state, leadStatusData: temp1 || [], leasReportDwnCalled: false, loading: false };

    case LEAD_STATUS_REPORT_FAILED:
      return { ...state, leasReportDwnCalled: false };

    case KYP_REPORT_DATA:
      return { ...state, kypReportDwnCalled: true, loading: true };
    case KYP_REPORT_DATA_SUCCESS:
      return { ...state, kypData: action.data || [], kypReportDwnCalled: false, loading: false };
    case KYP_REPORT_DATA_FAILED:
      return { ...state, kypReportDwnCalled: false };
    case HCR_REPORT_DATA:
      return { ...state, hcrReportDwnCalled: true, loading: true };
    case HCR_REPORT_DATA_SUCCESS:
      return { ...state, hcrData: action.data || [], hcrReportDwnCalled: false, loading: false };
    case HCR_REPORT_DATA_FAILED:
      return { ...state, hcrReportDwnCalled: false };
    case HCR_REPORT_RESET:
      return { ...state, hcrData: [], loading: false, error: null, hcrReportDwnCalled: false };
    case ENACH_REPORT_DATA:
      return { ...state, enachReportDwnCalled: true, loading: true };
    case ENACH_REPORT_DATA_SUCCESS:
      return { ...state, enachData: action.data || [], enachReportDwnCalled: false, loading: false };
    case ENACH_REPORT_DATA_FAILED:
      return { ...state, enachReportDwnCalled: false };
    case ENACH_REPORT_RESET:
      return { ...state, enachData: [], loading: false, error: null, enachReportDwnCalled: false };
    case KYP_REPORT_RESET:
      return { ...state, kypData: [], loading: false, error: null, kypReportDwnCalled: false };
    default:
      return { ...state };
  }
};
